import { z } from "zod";

const positionSchema = z.object({ x: z.number().finite(), y: z.number().finite() }).passthrough();
export const boardSnapshotSchema = z.object({
  format: z.enum(["reactflow"]).optional(),
  version: z.number().int().min(1).max(1).optional(),
  nodes: z.array(z.object({
    id: z.string().min(1),
    type: z.string().optional(),
    position: positionSchema,
    group_id: z.string().min(1).nullable().optional(),
    zIndex: z.number().finite().optional(),
    data: z.record(z.string(), z.unknown()).optional(),
  }).passthrough()),
  edges: z.array(z.object({
    id: z.string().min(1), source: z.string().min(1), target: z.string().min(1),
    type: z.string().optional(), data: z.record(z.string(), z.unknown()).optional(),
  }).passthrough()).optional(),
  viewport: positionSchema.extend({ zoom: z.number().finite().positive() }).passthrough().optional(),
}).passthrough();
